const ID_TOKEN_KEY       = "id_token";
const IMPERSONATE_FLAG   = "is_impersonating";
const MASTER_ID_KEY      = "master_user_id";
const MASTER_TOKEN_KEY          = "master_user_token";
const IMPERSONATED_USER_ID_KEY = "impersonated_user_id";

/* tokens ------------------------------------------------- */
export const getToken   = ()   => window.localStorage.getItem(ID_TOKEN_KEY);
export const saveToken  = t    => window.localStorage.setItem(ID_TOKEN_KEY, t);
export const destroyToken = () => window.localStorage.removeItem(ID_TOKEN_KEY);

export const getMasterToken = () => window.localStorage.getItem(MASTER_TOKEN_KEY);
export const saveMasterToken = t => window.localStorage.setItem(MASTER_TOKEN_KEY, t);
export const destroyMasterToken = () => window.localStorage.removeItem(MASTER_TOKEN_KEY);


/* impersonation flag ------------------------------------- */
export const setImpersonating = f =>
    window.localStorage.setItem(IMPERSONATE_FLAG, f ? "1" : "0");

export const isImpersonating = () =>
    window.localStorage.getItem(IMPERSONATE_FLAG) === "1";

export const clearImpersonating = () =>
    window.localStorage.removeItem(IMPERSONATE_FLAG);

/* master user id ----------------------------------------- */
export const setMasterId = id =>
    window.localStorage.setItem(MASTER_ID_KEY, String(id));

export const getMasterId = () =>
    Number(window.localStorage.getItem(MASTER_ID_KEY) || 0);

export const clearMasterId = () =>
    window.localStorage.removeItem(MASTER_ID_KEY);

/* impersonated user id ----------------------------------- */
export const setImpersonatedUserId = id =>
    window.localStorage.setItem(IMPERSONATED_USER_ID_KEY, String(id));

export const getImpersonatedUserId = () =>
    Number(window.localStorage.getItem(IMPERSONATED_USER_ID_KEY) || 0);

export const clearImpersonatedUserId = () =>
    window.localStorage.removeItem(IMPERSONATED_USER_ID_KEY);

export default {
  getToken, saveToken, destroyToken,
  setImpersonating, isImpersonating, clearImpersonating,
  setMasterId, getMasterId, clearMasterId,
  getMasterToken, saveMasterToken, destroyMasterToken,
  setImpersonatedUserId, getImpersonatedUserId, clearImpersonatedUserId
};
